
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex.js';
import request from './request.js'

import VueWechatTitle from 'vue-wechat-title';

import Vant from 'vant';
import 'vant/lib/index.css';
import MuseUI, { Form } from 'muse-ui';
import moment from 'moment';
import selectPick from '@/components/selectPick'
import selectMerchant from '@/components/selectMerchant'
import selectTime from '@/components/selectTime';
import AuditAsyn from './components/AuditAsyn/index.js'
import '@/assets/icon/iconfont.css'
import '@/assets/css/index.css'
import '@/assets/css/vant.css'
import '@/assets/css/muse-ui.css'
import 'muse-ui/dist/muse-ui.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
 
// 配置项
Viewer.setDefaults({
  Options: {
    'inline': true, // 启用 inline 模式
    // 'button': true, // 显示右上角关闭按钮
    // 'navbar': true, // 显示缩略图导航
    // 'title': true, // 显示当前图片的标题
    // 'toolbar': true, // 显示工具栏
    'tooltip': true, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 图片是否可缩放
    'rotatable': true, // 图片是否可旋转
    'scalable': true, // 图片是否可翻转
    'transition': true, // 使用 CSS3 过度
    'fullscreen': true, // 播放时是否全屏
  }
})
Vue.use(MuseUI)
Vue.use(Vant);
Vue.use(AuditAsyn) // 全局使用loading
Vue.use(VueWechatTitle);

Vue.prototype.router = router;
Vue.prototype.$request = request;
Vue.prototype.moment = moment;
Vue.config.productionTip = false

Vue.component('select-pick', selectPick)
Vue.component('select-merchant', selectMerchant)
Vue.component('select-time', selectTime)
Vue.filter("money", function (value) {   //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  if (/^d*(?:.d{0,2})?$/.test(value)) {
      return (value * 1).toFixed(2);
  } else {
      if (value || value == 0) {
          return (value * 1).toFixed(2);
      } else {
          return '0.00';
      }
  }
});
// /*
// *获取url中携带的参数
// *accessKey
// *token
// */.
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) { return pair[1]; }
  }
  return (false);
}
if(getQueryVariable("payBack")==1){
  window.payBack=JSON.parse(localStorage.getItem("account"))
}else{
  window.payBack=''
}
Vue.mixin({
  beforeRouteLeave:function(to, from, next){
      if (from && from.meta.rank && to.meta.rank && from.meta.rank>to.meta.rank && from.meta.keepAlive)
      {//此处判断是如果返回上一层，你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
          if (this.$vnode && this.$vnode.data.keepAlive)
          {
              if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache)
              {
                  if (this.$vnode.componentOptions)
                  {
                      var key = this.$vnode.key == null
                                  ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
                                  : this.$vnode.key;
                      var cache = this.$vnode.parent.componentInstance.cache;
                      var keys  = this.$vnode.parent.componentInstance.keys;
                      if (cache[key])
                      {
                          if (keys.length) {
                              var index = keys.indexOf(key);
                              if (index > -1) {
                                  keys.splice(index, 1);
                              }
                          }
                          delete cache[key];
                      }
                  }
              }
          }
          this.$destroy();
      }
      next();
  },
});
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js